import React from "react";
import Button from "components/CustomButton/CustomButton.jsx";
import { Link } from 'react-router-dom';
import ButtonWithTooltip from "../../components/Custom/ButtonWithTooltip";
import { withTranslation } from 'react-i18next';

class EditProjectLink extends React.Component {
    render() {
        const { t } = this.props;
        return (
            <Link to={"/projects/edit/" + this.props.id} >
                <ButtonWithTooltip
                    id={"editProject_" + this.props.id}
                    color="warning"
                    size="sm"
                    round
                    icon
                    tooltipText={t("Modifica")}
                >
                    <i className="fa fa-edit" />
                </ButtonWithTooltip>
            </Link>
        );
    }
}

export default EditProjectLink = withTranslation()(EditProjectLink);


// WEBPACK FOOTER //
// ./src/views/Projects/EditProjectLink.jsx